import {Keyword} from "../domain/entities/keyword.entity";
import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

export class CreateKeywordCommand extends AbstractCommand<Keyword> {

    public name = CommandName.CREATE_KEYWORD;

    public tags: string[] = [`entity`, `create`, `keyword`];

    constructor(payload: Keyword) {
        super('keyword', payload.uid, payload);
    }
}